import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RewardsWalletService } from '@fgb/core';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-marketplace-wallet-page',
  templateUrl: './marketplace-wallet-page.component.html',
  styleUrl: './marketplace-wallet-page.component.scss',
})
export class MarketplaceWalletPageComponent implements OnInit {
  constructor(private route: ActivatedRoute, private rewardsWalletService: RewardsWalletService) {}
  id: string;
  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id') || '0';
    firstValueFrom(this.rewardsWalletService.fetchWalletItems());
    
  }
}
